export enum RouteList {
  Redaction = '/dataroom/[dataroomName]/redaction',
  ManagePermissionGroups = '/dataroom/[dataroomName]/settings/permission-groups',
  ManageUsers = '/dataroom/[dataroomName]/settings/users-permissions',
}
